module.exports = __webpack_public_path__ + "img/CC-BY-NC.0a27805b.png";